import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-gdo-vehicle',
    templateUrl: './gdo-vehicle.component.html',
    styleUrls: ['./gdo-vehicle.component.scss'],
    standalone: false
})
export class GdoVehicleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
}
